define('_collections/Messages',[
	'_models/Message'
],
function(
	MessageModel
) {
	return Backbone.Collection.extend({

		url : function() {
			var path =  "/_api/v0/site/" + Backstage.Model.Default.get('site_url') + "/messages";
			return path;
		},

		model: MessageModel,

		fetch : function(options) {
		
			if ( $("script[data-set='Messages']").html() ) {
				this.set( $.parseJSON( $("script[data-set='Messages']").html() ), options );
				$("script[data-set='Messages']").remove();
			} else {
				return Backbone.Model.prototype.fetch.apply(this, arguments);
			}

		}
	});
});

